import Client from './KomodoClient';
import { unwrapEnvelope } from './KomodoAuth';
import { parseKomodoJson } from './bigint';
import { PAGE_ALL, pagerRows } from './Resource';

// komodo data importer: api/material-upload (upload records + progress) and api/import (MaterialBase
// validate / save / process). Template download, MaterialBase parsing and the xlsx re-exports are
// portal-specific endpoints added in feature/portal-config.
const enc = encodeURIComponent;

// MaterialUploadReq { deptCode, buzType } → PagerRecord<ImportUploadDTO>
const uploads = (query) =>
	Client.post('/api/material-upload/query-pager', {
		...PAGE_ALL,
		pageItems: 500,
		...(query || {}),
	}).then(pagerRows);
// MaterialUploadReq { filePath, deptCode, buzType } → SaveBillOperationResult
const createUpload = (req) => Client.post('/api/material-upload', req);
const upload = (id) => Client.get(`/api/material-upload/${enc(id)}`);
const uploadSubs = (id) =>
	Client.get(`/api/material-upload/upload-sub/${enc(id)}`);

// ImportBackendValidationQuery → failed rows only
const validateMaterialBase = (rows) =>
	Client.post('/api/import/vaildation/material-base/query-list', {
		materialValidationList: rows.map((r) => ({
			lineNo: r.lineNo,
			itemCode: r.itemCode,
			unitBarcode: r.unitBarcode,
			unitOfMeasurement: r.unitOfMeasurement,
		})),
	});
// ImportDataDTO { uploadMainID, fileName, importMaterial } → SaveBillOperationResult
const batchSaveMaterialBase = (dto) =>
	Client.post('/api/import/batch-save/material-base', dto);
const processImport = (id) =>
	Client.get(`/api/import/process-import/${enc(id)}`);

const readBlobText = (blob) =>
	typeof blob.text === 'function'
		? blob.text()
		: new Promise((resolve) => {
				const reader = new FileReader();
				reader.onload = () => resolve(reader.result);
				reader.readAsText(blob);
		  });

// Komodo answers a MessageException with its JSON envelope (HTTP 200); with responseType blob the
// client cannot see it, so sniff the content type and raise the komodo error instead of saving it.
export const unwrapBlob = async (response) => {
	const blob =
		response && response.data !== undefined ? response.data : response;
	if (blob && /json/i.test(String(blob.type || ''))) {
		unwrapEnvelope(parseKomodoJson(await readBlobText(blob)));
	}
	return blob;
};

// Portal endpoints (binary): template / re-export come back as blobs. The JSON client lets
// non-envelope bodies through as the raw axios response.
const download = (url) =>
	Client.get(url, undefined, {
		responseType: 'blob',
		transformResponse: (d) => d,
	}).then(unwrapBlob);
const template = (buzType) => download(`/api/import/template/${enc(buzType)}`);
const uploadFile = (id, kind) =>
	download(`/api/material-upload/upload-sub-file/${enc(id)}?kind=${enc(kind)}`);
// multipart → { fileName, rows: ImportMaterialInfoBaseCheckDTO[] }
const parseMaterialBase = (file) => {
	const form = new FormData();
	form.append('file', file, file.name);
	// 4th argument: axios options (the 3rd is the query string, which once carried these headers).
	return Client.post('/api/import/material-base/parse', form, null, {
		headers: { 'Content-Type': 'multipart/form-data' },
	});
};

export const saveBlob = (blob, fileName) => {
	const url = window.URL.createObjectURL(blob);
	const a = document.createElement('a');
	a.href = url;
	a.download = fileName;
	document.body.appendChild(a);
	a.click();
	document.body.removeChild(a);
	setTimeout(() => window.URL.revokeObjectURL(url), 1000);
};

export default {
	uploads,
	createUpload,
	upload,
	uploadSubs,
	validateMaterialBase,
	batchSaveMaterialBase,
	processImport,
	template,
	uploadFile,
	parseMaterialBase,
	saveBlob,
};
